import { ReactElement } from 'react';
import { TextField, useField } from '@ff-it/form';
import { Fieldset, FormInlineError } from 'components';
import { coerceEmptyToNull } from 'utilities';

const KEEP_HELP = 'Leave blank to keep current';

function useHasValue(name: string): boolean {
  const {
    input: { value },
  } = useField(name, { subscription: { value: true } });
  return Boolean(value);
}

export function OneCConfigFields(): ReactElement {
  const passwordSet = useHasValue('onec.password_set');
  const usernameEntered = useHasValue('onec.username');
  return (
    <Fieldset title="1C integration">
      <FormInlineError name="onec" />
      <div className="row">
        <TextField name="onec.endpoint" label="Sync endpoint" className="col-md-6" required {...coerceEmptyToNull} />
        <TextField name="onec.username" label="Username" className="col-md-6" {...coerceEmptyToNull} />
        <TextField
          name="onec.password"
          label="Password"
          className="col-md-6"
          required={usernameEntered && !passwordSet}
          help={passwordSet ? KEEP_HELP : undefined}
          {...coerceEmptyToNull}
        />
      </div>
    </Fieldset>
  );
}
